import './App.css';
import MainComponent from './Components/MainComponent';

function App() {
  return (
    <>
      <MainComponent/>
    </>
  );
}

export default App;
